import { Button } from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import commonUtils from '@/utils/commonUtils'

interface DataRow {
  baseDt: string
  batchNm: string
  seq: number
  bizCd: string
}

const Component = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
`
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`

const More = styled.span`
  font-size: 0.7rem;
  &:hover {
    cursor: pointer;
  }
`

const SubTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  color: #666;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  justify-content: space-between;
`

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`

const NoData = styled.div`
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #ddd;
  font-size: 0.7rem;
  align-items: center;
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
  font-size: 0.7rem;
  align-items: center;

  & > div {
    text-align: center;
    align-items: center;
  }

  & > div:nth-child(1) {
    flex: 2;
  }
  & > div:nth-child(2),
  & > div:nth-child(3) {
    flex: 3;
  }
  & > div:nth-child(4) {
    flex: 1;
  }
`

const MainBatchFailList: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()

  const today = new Date()
  const before1Month = new Date()
  before1Month.setMonth(today.getMonth() - 1)
  const before1Week = new Date()
  before1Week.setDate(today.getDate() - 7)

  const [totalCnt, setTotalCnt] = useState(0)
  const [batchFailList, setBatchFailList] = useState<DataRow[]>([])

  const getBatchFailList = async () => {
    const response = await axios.post('/log/list', {
      inqyStartDate: before1Week
        .toISOString()
        .split('T')[0]
        .replaceAll('-', ''),
      inqyEndDate: today.toISOString().split('T')[0].replaceAll('-', ''),
      page: 1,
      perPage: 10,
      siteType: '02', // 배치
      logLayer: 'BE', // 백엔드
      logType: 'ERROR',
    })

    if (response.status === 200) {
      setTotalCnt(response.data.data.totalCnt)
      const list = response.data.data.list
      const parseList = list
        .map((item: any) => {
          const logMsg = item.logMsg
          const match = logMsg.match(/^(.+)\((\d+)\):(.+)$/)
          if (!match) return null
          const [, batchNm, seq, bizCd] = match
          const baseDt = item.logDate
          return { batchNm, seq, bizCd, baseDt }
        })
        .filter(Boolean)
      setBatchFailList(parseList)
    } else {
      console.log('comLog list catch error', response)
    }
  }

  useEffect(() => {
    getBatchFailList()
  }, [])

  return (
    <Component>
      {/* 타이틀 */}
      <Title>
        <h4>배치실패목록</h4>
        <More
          onClick={() => {
            navigate('/comLog', {
              state: {
                searchData: {
                  inqyStartDate: before1Week.toISOString().split('T')[0],
                  inqyEndDate: today.toISOString().split('T')[0],
                  siteType: '02', // 배치
                  logLayer: 'BE', // 백엔드
                  logType: 'ERROR',
                },
              },
            })
          }}
        >
          더보기
        </More>
        {/* <span style={{ fontSize: '0.7rem', color: '#888' }}>{before1Week.toISOString().split('T')[0].replaceAll("-",".")} ~ {today.toISOString().split('T')[0].replaceAll("-",".")}</span> */}
      </Title>

      {/* 부제목 */}
      <SubTitle>
        <span>
          {before1Week.toISOString().split('T')[0].replaceAll('-', '.')} ~{' '}
          {today.toISOString().split('T')[0].replaceAll('-', '.')}
        </span>
        <span>총 {totalCnt} 건</span>
      </SubTitle>

      {/* 그리드 */}
      <Grid>
        <Row>
          <div>일자</div>
          <div>배치명</div>
          <div>업체코드</div>
          <div></div>
        </Row>
        {batchFailList.length === 0 ? (
          <NoData>실패내역이 없습니다.</NoData>
        ) : (
          batchFailList.slice(0, 10).map((log: DataRow, index) => (
            <Row key={index}>
              <div>{commonUtils.dateStrChgFomat(log.baseDt, 'yyyy.MM.dd')}</div>
              <div>{log.batchNm}</div>
              <div>{log.bizCd}</div>
              <div>
                <Button
                  color="neverbe"
                  variant="texted"
                  size="xs"
                  onClick={() => {
                    navigate('/batchExec/batchFailList', {
                      state: {
                        baseDt: log.baseDt,
                        batchNm: log.batchNm,
                        bizCd: log.bizCd,
                        batchSeq: log.seq,
                      },
                    })
                  }}
                >
                  <span style={{ textDecoration: 'underline' }}>상세</span>
                </Button>
              </div>
            </Row>
          ))
        )}
      </Grid>
    </Component>
  )
}

export default MainBatchFailList
